import React, { useState } from 'react';
import { login } from '../../components/services/server-api/api';
import { useNavigate } from 'react-router-dom'; 
import { useAuth, useLoading } from '../../components/services/check_login';
import { FaSignInAlt, FaEye, FaEyeSlash } from 'react-icons/fa';
import { motion } from 'framer-motion';
import '../../assets/css/login.css';

const Login = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { login: setAuth } = useAuth();
  const navigate = useNavigate();
  const { showLoading, hideLoading } = useLoading();

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    showLoading();
    try {
      const response = await login(credentials);
      setAuth(response.user); // Pass user data to context
      hideLoading();
      navigate('/');
    } catch (err) {
      hideLoading();
      setError('Incorrect username or password');
      document.getElementById('login-form').classList.add('shake');
      setTimeout(() => {
        document.getElementById('login-form').classList.remove('shake');
      }, 500);
    }
  };

  return (
    <div className="fullscreen-login-container">
      <div className="fullscreen-login-background">
        <div className="background-overlay"></div>
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>
      
      <motion.form 
        id="login-form"
        className="fullscreen-login-form"
        onSubmit={handleSubmit}
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <div className="form-header">
          <h1 className='logo'>
            <img src="/logo.png" alt="Content Craft Logo" className="logo-light" />
            <img src="/logo_dark.png" alt="Content Craft Logo" className="logo-dark" />
          </h1>
          <p>Sign in to your creative dashboard</p>
        </div>
        
        {error && (
          <motion.div 
            className="error-message"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
          >
            {error}
          </motion.div>
        )}
        
        <div className="input-group">
          <input 
            name="username" 
            placeholder="Username" 
            onChange={handleChange} 
            required 
            className="fullscreen-input"
          />
        </div>
        
        <div className="input-group password-input-group">
          <input 
            name="password" 
            type={showPassword ? "text" : "password"} 
            placeholder="Password" 
            onChange={handleChange} 
            required 
            className="fullscreen-input password-input"
          />
          <button 
            type="button" 
            className="password-toggle-button"
            onClick={() => setShowPassword(!showPassword)}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? <FaEyeSlash className="eye-icon" /> : <FaEye className="eye-icon" />}
          </button>
        </div>
        
        <motion.button 
          type="submit" 
          className="fullscreen-login-button"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <FaSignInAlt className="button-icon" /> 
          <span>Login</span>
        </motion.button>
      
      </motion.form>
    </div>
  );
};

export default Login;